import React, { useState } from 'react'
import { FileUploader } from 'react-drag-drop-files';
import { FormatoCantidad } from '../helpers/functionGlobal';

const FileUploadIcon = ({ name, fileTypes, multiple = false, maxSize = 10, textoTipoDoc, textoFormatos, textoLinkCarga, textoLinkReemplaza, handleChange, tipoDocumento }) => {
    
    const [file, setFile] = useState(null);
    const [error, setError] = useState("");

    const archivos = (files) => {
        if(!multiple) {
            return <>
                <b className='name-image'>Archivo subido</b>
                <p className='name-image nombre-real mb-0'>{files ? files.name : ""}</p>
                <p className='size-image'>{files ? FormatoCantidad(files.size, 0, "", ",") : ""} KB</p>
            </>
        } else {
            return Object.values(files).map((archivo, index) => {
                return <div key={index}>
                    <b className='name-image'>{archivo ? archivo.name : ""}</b>
                    <p className='size-image'>{archivo ? FormatoCantidad(archivo.size, 0, "", ",") : ""} KB</p>
                </div>
            });
        }
    }

    return (
        <>
            <FileUploader
                multiple={multiple}
                maxSize={maxSize}
                handleChange={((file) => {
                    if(multiple) {
                        if(file.length <= 10 && file.length > 0) {
                            setFile(file);
                            handleChange(file, name, tipoDocumento);
                            setError("");
                        } else {
                            if(file.length >= 10) {
                                setError("No se puede cargar mas de 10 archivos");
                                setFile(null);
                            }
                        }
                    } else {
                        setError("");
                        setFile(file);
                        handleChange(file, name, tipoDocumento);
                    }
                    
                })}
                name={name}
                types={fileTypes}
                classes = {`carga-documento-icon${file === null ? '' : " active"}`}
                onSizeError = {(file) => {
                    setError(`El tamaño de la imagen debe ser de ${maxSize} MB`);
                }}
            >
                {
                file === null ?
                <div className='texto-default flex-row'>
                    <i className='icon-upload flex-shrink-0 m-0'></i>
                    <div className='ms-3'>
                        <b className='texto-formatos'>{textoFormatos}</b>
                        <p className='nav-link m-0'>{textoLinkCarga}</p>
                    </div>
                    
                </div>
                :
                <div className='datos-image w-100'>
                    <div className='d-flex m-0 w-100 align-items-center'>
                        <i className='icon-picture flex-shrink-0'></i>
                        <div className='flex-shrink-1'>
                            {archivos(file)}
                            <p className='nav-link m-0 text-start'>{textoLinkReemplaza}</p>
                        </div>
                    </div>
                    <i className='icon-button-select flex-shrink-2'></i>
                </div>
                }
            </FileUploader>
            <p className='texto-error'>{error}</p>
        </>
    )
}

export default FileUploadIcon